import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "page-header-text" }, [
  /*#__PURE__*/_createTextVNode("Deine "),
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "App"),
  /*#__PURE__*/_createTextVNode(" für "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" mehr Entspannung und Zufriedenheit")
], -1)
const _hoisted_2 = { class: "login-container-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageHeader = _resolveComponent("PageHeader")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", {
    class: "login-container",
    style: _normalizeStyle('height: ' + _ctx.windowHeight + 'px;')
  }, [
    _createVNode(_component_PageHeader, { defaultHeader: true }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Button, {
        text: _ctx.$t('button.register'),
        onHandleClicked: _ctx.handleShowRegisterForm
      }, null, 8, ["text", "onHandleClicked"]),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('already_registered')) + "?", 1),
      _createVNode(_component_Button, {
        text: _ctx.$t('button.login'),
        secondary: true,
        onHandleClicked: _ctx.handleShowLoginForm
      }, null, 8, ["text", "onHandleClicked"])
    ])
  ], 4))
}